__turbopack_context__.v({
  "active": "tabs-module-scss-module__sSO_Wq__active",
  "tabs": "tabs-module-scss-module__sSO_Wq__tabs",
  "tabsContent": "tabs-module-scss-module__sSO_Wq__tabsContent",
  "tabsPanel": "tabs-module-scss-module__sSO_Wq__tabsPanel",
  "tabsTitle": "tabs-module-scss-module__sSO_Wq__tabsTitle",
  "tabsWrapper": "tabs-module-scss-module__sSO_Wq__tabsWrapper",
});
